import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ResniÄnost?",
  "description": "",
  "published": "2007-04-24T00:00:00.000Z",
  "redirect_from": ["/blog/resninost/swizec/226"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi sem se vkljuÄil v izziv, ki od Äloveka zahteva, da vsak dan proizvede fotografijo, priporoÄljivo sebe, in to poÄenja 365 dni. Sam izziv sicer traja Å¾e nekaj veÄ kot leto dni, vendar sem se vanj vkljuÄil šele kake štiri dni nazaj. Moram reÄi, da neizmerno uÅ¾ivam ... kdo bi si mislil, da je lahko tako zabavno.`}</p>
    <p>{`Na slashdotu sem prebral zanimiv Älanek in moram priznati, da se nisem lotil izvornega Älanka. Karkoli je Å¾e vsa znanstvena Å¾lobodravšÄina pomenila ... kaÅ¾e, da so fiziki konÄno odkrili nekaj substantivnega ozadja, da je resniÄnost odvisna od vsakega posameznika. Sedaj bom vsakiÄ, ko bo kdo preklel moje obnašanje in nazore, v njihovo faco potisnil spiske znanstvenih teoremov in jih za vekomaj utišal.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      